import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import Button from 'material-ui/Button';
import Loader from '../Parts/Loader';
import Wrapper from '../common/Wrapper';
import Header from '../common/Header';
import NotificationBar from '../Parts/NotificationBar.jsx'
import NotificationBanner from '../common/NotificationBanner';
import DashboardHeader from './sections/DashboardHeader';
import ActivityPanel from './panels/ActivityPanel';
import AppointmentNotification from './panels/AppointmentNotification';
import DelayLetterOrderNotification from './panels/DelayLetterOrderNotification';
import StatusChartPanel from './panels/StatusChartPanel';
import StatusOverviewAbstractPanel from './panels/StatusOverviewAbstractPanel';
import AchievementPanel from './panels/AchievementPanel';
import StatusDailyComparisonPanel from './panels/StatusDailyComparisonPanel';
import PlanDialog from '../SendLetter/dialogs/PlanDialog';
import DemoDialog from './dialogs/DemoDialog';
import LetterOrderCompleteDialog from '../Timeline/dialogs/LetterOrderCompleteDialog';
import FollowCallOrderCompleteDialog from '../Timeline/dialogs/FollowCallOrderCompleteDialog';
import { OwnerType, TimelineLabelType } from '../../constants/ComponentTypes';
import { hasKLFollowCallBeenEnabled } from '../../utils/userUtils';

const styles = () => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
  },

  main: {
    background: "#FAFAFA",
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },

  content: {
    transform: 'translateY(20px)',
    width: '100%',
    padding: '0 25px',
    boxSizing: 'border-box',
  },

  flexContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    position: 'relative',
    width: '100%',
  },

  half: {
    width: 'calc(50% - 15px)',
    marginBottom: '23px',
  },

  left: {
    flexDirection: 'column',
  },

  right: {
    flexWrap: 'wrap',
  },

  demoNotification: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  demoButton: {
    color: '#181819',
    fontSize: '13px',
    minWidth: 'unset',
    minHeight: 'unset',
    padding: '1px',
    marginLeft: '10px',
    textDecoration: 'underline',
  },
});

class OrderDashboard extends React.Component {
  initialState = {
    ownerType: OwnerType.OWN.value,
    showPlanDialog: false,
    showNotification: false,
    showOrderCompleteDialog: false,
    showDemoDialog: false,
    showFollowCallOrderCompleteDialog: false,
    order_contact_id: 0,
  }

  constructor(props) {
    super(props);
    const ownType = props.location.state && props.location.state.ownerType ? props.location.state.ownerType : OwnerType.OWN.value;
    this.state = { ...this.initialState, ...{ ownerType: ownType } };
  }

  componentDidMount() {
    // ユーザー情報を取得する
    this.props.getUserInfo(true);
    // 注文処理が終わった後のページであれば、ダイアログを表示
    if (this.props.routerInfo.state) {
      if (this.props.routerInfo.state.orderComplete) {
        this.toggleOrderCompleteDialog();
      } else if (this.props.routerInfo.state.followCallOrderComplete) {
        this.toggleFollowCallOrderCompleteDialog();
      }
    }
  }

  componentDidUpdate() {
    if (this.props.successMessage && this.props.successMessage !== '') {
      this.displayNotification(this.props.successMessage, "success");
    } else if (this.props.errorMessage && this.props.errorMessage !== '') {
      this.displayNotification(this.props.errorMessage, "error");
    } else if (this.props.shortMessage && this.props.shortMessage !== '') {
      this.displayNotification(this.props.shortMessage, "green");
    }
  }

  toggleDemoDialog = () => {
    this.setState({
      showDemoDialog: !this.state.showDemoDialog,
      showPlanDialog: false,
    });
  }

  togglePlanDialog = () => {
    this.setState({
      showPlanDialog: !this.state.showPlanDialog,
      showDemoDialog: false,
    });
  }

  toggleOrderCompleteDialog = () => {
    this.setState({ showOrderCompleteDialog: !this.state.showOrderCompleteDialog });
  }

  toggleFollowCallOrderCompleteDialog = () => {
    this.setState({ showFollowCallOrderCompleteDialog: !this.state.showFollowCallOrderCompleteDialog });
  }

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    })
  };

  handleOwnerTypeChange = (value) => {
    this.setState({
      ownerType: value,
    });
  }

  renderDemoDialog = () => {
    if (this.state.showDemoDialog) {
      return (
        <DemoDialog
          isOpen={this.state.showDemoDialog}
          toggleDialog={this.toggleDemoDialog}
          togglePlanDialog={this.togglePlanDialog}
          user={this.props.user}
        />
      );
    }
  }

  renderDemoNotification = () => {
    const { classes } = this.props;

    if (this.props.isDemo) {
      return (
        <div style={{ position: 'fixed', zIndex: 10000, top: 10, left: '50%', transform: 'translateX(-50%)' }}>
          <NotificationBar
            message={<div className={classes.demoNotification}>
              <span>デモを表示しています</span>
              <Button onClick={this.toggleDemoDialog} className={classes.demoButton}>詳細</Button>
            </div>}
            type="yellow"
            open={true}
            autoClose={false}
            style={{
              width: "280px",
              fontWeight: 'normal'
            }}
          >
          </NotificationBar>
        </div>
      );
    }
  }

  renderPlanDialog = () => {
    if (this.state.showPlanDialog) {
      return (
        <PlanDialog
          isOpen={this.state.showPlanDialog}
          toggleDialog={this.togglePlanDialog}
        />
      )
    }
  }

  renderOrderCompleteDialog = () => {
    if (this.state.showOrderCompleteDialog) {
      return (
        <LetterOrderCompleteDialog
          isOpen={this.state.showOrderCompleteDialog}
          toggleDialog={this.toggleOrderCompleteDialog}
          time={(this.props.routerInfo && this.props.routerInfo.state) ? this.props.routerInfo.state.orderTime : ''}
          orderScheduledAt={(this.props.routerInfo && this.props.routerInfo.state) ? this.props.routerInfo.state.orderScheduledAt : ''}
          buttonText="ダッシュボードを確認"
        />
      )
    }
  }

  renderFollowCallOrderCompleteDialog = () => {
    if (this.state.showFollowCallOrderCompleteDialog) {
      return (
        <FollowCallOrderCompleteDialog
          isOpen={this.state.showFollowCallOrderCompleteDialog}
          toggleDialog={this.toggleFollowCallOrderCompleteDialog}
          buttonText="ダッシュボードを確認"
        />
      )
    }
  }

  renderNotification = () => {
    if (this.state.showNotification) {
      return (
        <div style={{ position: 'fixed', zIndex: 10000, top: 10, width: '98%', left: '1%' }}>
          <NotificationBar
            message={this.state.message}
            type={this.state.messageType}
            open={this.state.showNotification}
            onHandleClose={() => {
              this.setState({ showNotification: false })
            }}
            autoClose={false}
            style={{
              width: this.state.messageType === "green" ? "fit-content" : '100%',
            }}
          >
          </NotificationBar>
        </div>
      );
    }
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user || this.props.isProxyLoginLoading) {
      return (
        <Loader type='color' />
      )
    } else {
      return (
        <Wrapper className={classes.root}>
          <NotificationBanner user={this.props.user} />
          <Header title="ダッシュボード" type="dark" hasBackBtn={false} />
          <div className={classes.main}>
            <DashboardHeader
              goTo={this.props.goTo}
              ownerType={this.state.ownerType}
              togglePlanDialog={this.togglePlanDialog}
              handleOwnerTypeChange={this.handleOwnerTypeChange}
            />

            <div className={classes.content}>
              <div className={classes.flexContainer}>
                <div className={classNames(classes.half, classes.left)}>
                  <AchievementPanel
                    ownerType={this.state.ownerType}
                    togglePlanDialog={this.togglePlanDialog}
                  />
                  <div className={classes.flexContainer}>
                    <div className={classes.half} style={{ width: (this.props.isDemo || hasKLFollowCallBeenEnabled(this.props.user)) ? 'calc(50% - 15px)' : '100%' }}>
                      <StatusOverviewAbstractPanel
                        goTo={this.props.goTo}
                        ownerType={this.state.ownerType}
                        type={TimelineLabelType.QR_CODE_REACTION.value}
                        isLoading={this.props.isLoadingQrCode}
                        pageInfo={this.props.pageInfoQrCode}
                        getStatus={this.props.getPersonQrCodeStatus}
                        togglePlanDialog={this.togglePlanDialog}
                      />
                    </div>
                    {(this.props.isDemo || hasKLFollowCallBeenEnabled(this.props.user)) && (
                      <div className={classes.half}>
                        <StatusOverviewAbstractPanel
                          goTo={this.props.goTo}
                          ownerType={this.state.ownerType}
                          type={'lead_note'}
                          isLoading={this.props.isLoadingLeadNote}
                          pageInfo={this.props.pageInfoLeadNote}
                          getStatus={this.props.getPersonLeadNoteStatus}
                          togglePlanDialog={this.togglePlanDialog}
                        />
                      </div>
                    )}
                  </div>
                  <ActivityPanel
                    ownerType={this.state.ownerType}
                    goTo={this.props.goTo}
                    togglePlanDialog={this.togglePlanDialog}
                  />
                </div>

                <div className={classNames(classes.flexContainer, classes.right, classes.half)}>
                  {(this.props.isDemo || hasKLFollowCallBeenEnabled(this.props.user)) && (
                    <AppointmentNotification
                      ownerType={this.state.ownerType}
                      goTo={this.props.goTo}
                    />
                  )}
                  <DelayLetterOrderNotification
                    ownerType={this.state.ownerType}
                    goTo={this.props.goTo}
                  />
                  <StatusChartPanel
                    goTo={this.props.goTo}
                    ownerType={this.state.ownerType}
                    togglePlanDialog={this.togglePlanDialog}
                  />
                  <StatusDailyComparisonPanel
                    ownerType={this.state.ownerType}
                  />
                </div>
              </div>
            </div>
          </div>

          {this.renderPlanDialog()}
          {this.renderOrderCompleteDialog()}
          {this.renderFollowCallOrderCompleteDialog()}
          {this.renderNotification()}
          {this.renderDemoNotification()}
          {this.renderDemoDialog()}
        </Wrapper>
      )
    }
  }
}

OrderDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  showDemoData: PropTypes.bool,
  isProxyLoginLoading: PropTypes.bool,
  location: PropTypes.object,
  isLoadingLeadNote: PropTypes.bool,
  pageInfoLeadNote: PropTypes.object,
  isLoadingQrCode: PropTypes.bool,
  pageInfoQrCode: PropTypes.object,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  getPersonQrCodeStatus: PropTypes.func.isRequired,
  getPersonLeadNoteStatus: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  routerInfo: PropTypes.object,
  isDemo: PropTypes.bool,
};

export default withStyles(styles)(OrderDashboard);



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/OrderDashboard.jsx